module.exports = {"211204001":"红旗街道","211204002":"向阳街道","211204101":"张相镇","211204102":"杨木林子镇","211204203":"聂家满族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211204.json
// module id = 536
// module chunks = 0